import React, { useEffect } from 'react';
import './Gallery.css';

// Instagram posts configuration
const instagramPosts = [
  'https://www.instagram.com/p/DZdZTT6yw69/?utm_source=ig_web_button_share_sheet&igsh=MzRlODBiNWFlZA==',
  'https://www.instagram.com/reel/DZLQPRJSjMg/?utm_source=ig_web_button_share_sheet&igsh=MzRlODBiNWFlZA==',
  'https://www.instagram.com/reel/DZF2Bu9yqs1/?utm_source=ig_web_button_share_sheet&igsh=MzRlODBiNWFlZA==',
  'https://www.instagram.com/reel/DZF2Bu9yqs1/?utm_source=ig_web_button_share_sheet&igsh=MzRlODBiNWFlZA==',
  'https://www.instagram.com/reel/DZD9bzdSu8R/?utm_source=ig_web_button_share_sheet&igsh=MzRlODBiNWFlZA==',
  'https://www.instagram.com/reel/DYnRJcDyU-V/?utm_source=ig_web_button_share_sheet&igsh=MzRlODBiNWFlZA==',
  'https://www.instagram.com/p/DYXG0iKO6Sr/?utm_source=ig_web_button_share_sheet&igsh=MzRlODBiNWFlZA==',
  'https://www.instagram.com/reel/DO81PZ1DtPm/?utm_source=ig_web_button_share_sheet&igsh=MzRlODBiNWFlZA==',
  'https://www.instagram.com/reel/DKDgU5QP_XX/?utm_source=ig_web_button_share_sheet&igsh=MzRlODBiNWFlZA==',
];

export default function Gallery() {
  useEffect(() => {
    // Load Instagram embed script
    const script = document.createElement('script');
    script.src = 'https://www.instagram.com/embed.js';
    script.async = true;
    document.body.appendChild(script);

    // If Instagram script was already loaded, call its processing function
    if (window.instgrm) {
      window.instgrm.Embeds.process();
    }

    return () => {
      // Cleanup
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return (
    <div className="container py-5">
      <h2 className="text-center display-5 mb-5 fade-in" style={{ color: '#2c2c2c', fontWeight: 700 }}>
        Our Latest on Instagram
      </h2>
      <p className="text-center text-muted mb-5" style={{ fontSize: '1.1rem' }}>
        Follow us @habibteachi for daily updates and behind-the-scenes content!
      </p>

      <div className="instagram-gallery">
        {instagramPosts.map((post, index) => (
          <div key={index} className="instagram-post fade-in" style={{ animationDelay: `${index * 0.1}s` }}>
            <blockquote
              className="instagram-media"
              data-instgrm-permalink={post}
              data-instgrm-version="14"
              style={{
                background: '#fff',
                border: 0,
                borderRadius: '3px',
                boxShadow: '0 0 1px 0 rgba(0,0,0,0.5), 0 1px 10px 0 rgba(0,0,0,0.15)',
                margin: '1px',
                maxWidth: '540px',
                minWidth: '326px',
                padding: 0,
                width: '100%',
              }}
            >
              <a href={post} target="_blank" rel="noopener noreferrer" style={{ color: '#000', textDecorationLine: 'none' }}>Loading...</a>
            </blockquote>
          </div>
        ))}
      </div>

      <div className="text-center mt-5">
        <a
          href="https://www.instagram.com/habibteachi/"
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-outline-dark btn-lg"
          style={{
            borderColor: '#d4a574',
            color: '#d4a574',
            fontWeight: 600,
            padding: '12px 40px',
            borderRadius: '50px',
            transition: 'all 0.3s ease',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = '#d4a574';
            e.currentTarget.style.color = 'white';
            e.currentTarget.style.borderColor = '#d4a574';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = 'transparent';
            e.currentTarget.style.color = '#d4a574';
            e.currentTarget.style.borderColor = '#d4a574';
          }}
        >
          Follow @habibteachi on Instagram
        </a>
      </div>
    </div>
  );
}
